import { ROLES } from "../../../../../helpers/commons.helpers";

const EVENT_ROLES = [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER];

/**
 * Events tool route definitions: list, create and view/edit.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
  {
    path: "/tools/events",
    name: "Events",
    meta: {
      modules: ["events"],
      requiresAuth: true,
      roles: EVENT_ROLES
    },
    component: () =>
      import(
        /* webpackChunkName: "EventsManager" */ "@/modules/tools/modules/events/pages/Events"
      )
  },
  {
    path: "/tools/events/new",
    name: "New Event",
    meta: {
      modules: ["events"],
      requiresAuth: true,
      roles: EVENT_ROLES
    },
    component: () =>
      import(
        /* webpackChunkName: "NewEvent" */ "@/modules/tools/modules/events/pages/NewEvent"
      )
  },
  {
    path: "/tools/events/:id",
    name: "Event Details",
    meta: {
      modules: ["events"],
      requiresAuth: true,
      roles: EVENT_ROLES
    },
    component: () =>
      import(
        /* webpackChunkName: "EventDetails" */ "@/modules/tools/modules/events/pages/EventDetails"
      )
  }
];
